import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { IconRegularDelivery, IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';
import { CypressTestNamespace } from '@utils/test';

import { ProgressBar } from '../ProgressBar';

import { FONT_SIZE } from './constants';
import {
  StyledFreeDeliveryWrapper,
  StyledTextRow,
  StyledText,
  StyledCheckoutPrice,
  StyledIconWrapper,
  StyledLink,
} from './styled';

export interface IFreeDeliveryProgressBarWrapperWithReco extends IBasicStyledProps {
  price: number;
  maxLimit: number;
  messages: {
    achievedFreeShipping: MessageDescriptor;
    amountUntilFreeDeliveryWithReco: MessageDescriptor;
    linkForRecoModal: MessageDescriptor;
  };
  onLinkClick: () => void;
}

export const FreeDeliveryProgressBarWrapperWithReco: ReactFCV<IFreeDeliveryProgressBarWrapperWithReco> = React.memo(
  ({ price, maxLimit, messages, onLinkClick, ...rest }) => {
    const isCompleted = maxLimit <= price;

    return (
      <StyledFreeDeliveryWrapper data-testid="free-delivery-progress-bar" {...rest}>
        <StyledTextRow>
          <StyledIconWrapper>
            <IconRegularDelivery color={'icon.highlight'} width="24px" height="24px" />
          </StyledIconWrapper>
          <StyledText isCompleted={isCompleted}>
            {isCompleted ? (
              <FormattedMessage {...messages.achievedFreeShipping} />
            ) : (
              <FormattedMessage
                {...messages.amountUntilFreeDeliveryWithReco}
                values={{
                  price: (
                    <StyledCheckoutPrice
                      isHighLighted={true}
                      firstCurrency={{
                        priceSize: FONT_SIZE,
                        currencySize: FONT_SIZE,
                        bold: true,
                      }}
                      secondCurrency={{
                        priceSize: FONT_SIZE,
                        currencySize: FONT_SIZE,
                        bold: true,
                      }}
                      separator={{
                        separatorSize: FONT_SIZE,
                        bold: true,
                      }}
                      price={maxLimit - price}
                    />
                  ),
                  link: (
                    <StyledLink onClick={onLinkClick}>
                      <FormattedMessage {...messages.linkForRecoModal} />
                    </StyledLink>
                  ),
                }}
              />
            )}
          </StyledText>
        </StyledTextRow>
        <ProgressBar
          className={CypressTestNamespace.EFreeDeliveryProgressBar.FREE_DELIVERY_PROGRESS_BAR}
          min={0}
          max={maxLimit}
          value={isCompleted ? maxLimit : price}
          undoneColor={'common.white'}
          successColor={'text.highlight'}
          maxWidth={28}
        />
      </StyledFreeDeliveryWrapper>
    );
  },
);
